module.exports = __webpack_public_path__ + "img/ganni-2.084bf94e.jpg";